import {AfterViewInit, Component, computed, ElementRef, inject, signal, viewChild} from '@angular/core';
import {CompareItemComponent} from './compare-item/compare-item.component';
import {CompareItemFeaturesComponent} from './compare-item-features/compare-item-features.component';
import {ResultsStore} from '../../../../shared/store/results.store';
import {IconsComponent} from '../../../../shared/components/icons/icons.component';

@Component({
  selector: 'app-compare-items',
  standalone: true,
  imports: [
    CompareItemComponent,
    IconsComponent
  ],
  templateUrl: './compare-items.component.html',
  styleUrl: './compare-items.component.css',
})
export class CompareItemsComponent implements AfterViewInit {
  private resultsStore = inject(ResultsStore);

  scrollContainer = viewChild.required<ElementRef<HTMLElement>>('scrollContainer');

  canScrollLeft = signal(false);
  canScrollRight = signal(false);

  ngAfterViewInit() {
    this.updateScrollButtons();

    const container = this.scrollContainer().nativeElement;
    container.addEventListener('scroll', () => this.updateScrollButtons());
  }

  updateScrollButtons() {
    const container = this.scrollContainer().nativeElement;
    const scrollLeft = container.scrollLeft;
    const maxScroll = container.scrollWidth - container.clientWidth;

    this.canScrollLeft.set(scrollLeft > 5);
    this.canScrollRight.set(scrollLeft < maxScroll - 5);
  }

  scrollNext() {
    const container = this.scrollContainer().nativeElement;
    container.scrollBy({ left: container.querySelector(':scope > div')!.clientWidth + (parseFloat(getComputedStyle(container).gap) || 0), behavior: 'smooth' });
    setTimeout(() => this.updateScrollButtons(), 400);
  }

  scrollPrev() {
    const container = this.scrollContainer().nativeElement;
    container.scrollBy({ left: -(container.querySelector(':scope > div')!.clientWidth + (parseFloat(getComputedStyle(container).gap) || 0)), behavior: 'smooth' });
    setTimeout(() => this.updateScrollButtons(), 400);
  }

  compareItems = computed(() => {
    return Object.entries(this.resultsStore.compare_items())
      .map(([key, item]) => ({ key, item }))
      .filter((item) => item.item);
  });
}
